import React, { useEffect, useState, useCallback } from 'react';
import { useAblContext } from '../../Hooks/useAblContext';
import api from '../../Services/api';
import MoviePanel from '../../Components/MoviePanel';
import MovieForm from '../../Components/MovieForm';

// Sö exibimos o painel caso a URL esteja diferente de NULL
export default function AddMovie() {
  const [company, setCompany] = useState<any>([])
  const [video, setVideo] = useState<any>(null)
  const abl = useAblContext();

  const request = async () => {
    const response = await api.get('company/video', { headers: { authorization: abl.token }})
    if(response.data){
      setCompany(response.data.videos);
      const videoWithNullUrl = response.data.videos.find((video:any) => video.url === null || video.url === "");
      setVideo(videoWithNullUrl)
      console.log("videoWithNullUrl")
      console.log(videoWithNullUrl)
    }
  }

  useEffect(() => {
    (async() => {
      await request();
    })()
  }, [])

  const handleOnSucess = async () => {
    await request();
  }



  return(
        <div className="container">
          <div className="text-center">
            <h3>Olá {company.companyName}</h3>
            <p>Seu cadastro foi aprovado e você pode fazer o upload do filme inscrito.</p>
            <hr/>
            {video === null || video === undefined ?
              <p>Todos os filmes já possuem videos</p> : <MovieForm video={video} onSuccess={handleOnSucess} />
            }
            {/*
              company.url ?
              <MoviePanel company={company} /> : <MovieForm onSuccess={handleOnSucess} />
            */}
            <MoviePanel company={company} />
          </div>

        </div>
  )
}
